import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Utils from '../../utility';
import { GlobalService } from '../../../services/global.service';
import { FundingSourceComponent } from '../funding-source/funding-source.component';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-pia-calculator',
  templateUrl: './pia-calculator.component.html',
  styleUrls: ['./pia-calculator.component.css']
})
export class PIAComponent implements OnInit {
  data;
  client;
  isSpouse: boolean = false;
  piaForm: FormGroup;
  dataSource: any[] = [];
  currentYear = new Date().getFullYear();
  displayCalcBtn: boolean = false;
  dateofBirth: any;
  startAge: number;
  lifeExpYear: number;

  yob;
  endOfPIAStartYear;
  endYear1;
  endOfPIAEndYear;

  constructor(private formBuilder: FormBuilder, private globalService: GlobalService, public dialogRef: MatDialogRef<FundingSourceComponent>, @Inject(MAT_DIALOG_DATA) data) {
    console.log(data)
    this.data = data.piaData;
    this.client = data.client;
    this.isSpouse = data.isSpouse;
  }

  ngOnInit() {
    this.dateofBirth = new Date(((this.isSpouse) ? this.client.clientProfile.Spouses[0].dob : this.client.client.DOB)).getFullYear();
    this.lifeExpYear = (((this.isSpouse) ? this.client.clientProfile.Spouses[0].LifeExpectancy : this.client.clientProfile.LifeExpectancy) - (this.currentYear - this.dateofBirth)) + this.currentYear;
    this.yob = this.dateofBirth + 14;
    this.endOfPIAStartYear = this.currentYear - this.yob + 1;
    this.endYear1 = this.dateofBirth + 30;
    var endYear2 = this.dateofBirth + 80;
    this.endOfPIAEndYear = endYear2 - this.endYear1 + 1;
    this.piaForm = this.formBuilder.group({
      startYear: [(this.data.startYear) ? this.data.startYear.toString() : '', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(this.yob), Validators.max(this.yob + this.endOfPIAStartYear)]],
      endYear: [(this.data.endYear) ? this.data.endYear.toString() : '', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      piaArray: new FormArray([])
    });

    if (this.data.details && this.data.details.length) {
      this.displayCalcBtn = true;
      for (let i = 0; i <= this.data.details.length; i++) {
        if (this.data.details[i] && this.data.details[i].Year)
          this.addPIAYear(this.data.details[i].Year, Utils.formatToCurrency(this.data.details[i].ActualEarnings));
      }
    }
  }

  getAgeFromYear(year, age) {
    console.log(year,age)
    const currentYear = new Date().getFullYear();
    const diff = year - currentYear;
    return age + diff
  }

  formatCurrency(val, i) {
    val = val.replace(/\D/g, '');
    (<FormArray>(<FormArray>this.piaForm.controls['piaArray']).controls[i]).controls['ActualEarnings'].patchValue(val ? Utils.formatToCurrency(Utils.formatToNumber(val)) : '');
  }

  close(update): void {
    console.log(this.piaForm.value)
    if (update) {
      for (var year of this.piaForm.value.piaArray) {
        year.ActualEarnings = Number(year.ActualEarnings) ? Number(year.ActualEarnings) : year.ActualEarnings.replace('$', '').replaceAll(',','');
      }
      this.getPIAObject()
    } else {
      if (this.piaForm.value.length > 0) {
        for (var year of this.piaForm.value.piaArray) {
          year.ActualEarnings = Number(year.ActualEarnings) ? Number(year.ActualEarnings) : year.ActualEarnings.replace('$', '').replaceAll(',','');
        }
        this.getPIAObject()
      } else {
        this.dialogRef.close();
      }
    }
  }

  get piaYears() {
    return this.piaForm.controls["piaArray"] as FormArray;
  }

  onChangePIAYear() {
    this.piaForm.get('endYear').setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(this.piaForm.value.startYear), Validators.max(this.lifeExpYear)])
    this.piaForm.get('endYear').updateValueAndValidity()

    if (this.displayCalcBtn) {
      this.calculatePIAYears();
    }
  }

  calculatePIAYears() {
    let temp = {}
    if (this.piaForm.get('startYear').valid && this.piaForm.get('endYear').valid) {
      for (let i = 0; i <= (this.piaForm.value.endYear - this.piaForm.value.startYear); i++) {
        const year = Number(this.piaForm.value.startYear) + i;

        if (year >= Number(this.piaForm.get('startYear').value) && year <= Number(this.piaForm.get('endYear').value)) {
            this.addPIAYear(year, '$0');
        }
      }
    }

    this.displayCalcBtn = true;
  }

  getPIAObject() {
    const birthday = new Date(((this.isSpouse) ? this.client.clientProfile.Spouses[0].dob : this.client.client.DOB));
    
    const piaArray = this.piaForm.value.piaArray.map((year) => {
      return {
        Year: year.Year,
        ActualEarnings: year.ActualEarnings,
        Age: this.getAgeFromYear(year.Year, this.calculateAge(birthday))
      }
    })

    var PIACalculator = {
      currentAge: this.calculateAge(this.dateofBirth),
      earningYear: piaArray
    }

    this.globalService.getPIA(PIACalculator)
      .subscribe(
        pia => {
          /* if (pia > 3627)
            pia = 3627 */
          /* if (pia > 3822){
            pia = 3822;
          } */
          if (pia > 4018){
            pia = 4018;
          }

          this.dialogRef.close({startYear: this.piaForm.value.startYear, endYear: this.piaForm.value.endYear, pia, details: piaArray});
        },
        error => console.log(error));
  }

  // TODO: Make utility file
  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  addPIAYear(year, value) {
    this.removePIAYears()

    const yearObj = new FormGroup(
      {
        Year: new FormControl(year),
        ActualEarnings: new FormControl(value || 0, [Validators.required])
      }
    )

    const seYearIdx = this.piaYears.value.findIndex(y => y.Year === yearObj.value.Year)

    if (seYearIdx > -1)
      this.piaYears.value[seYearIdx] = yearObj;
    else if (seYearIdx === -1)
      this.piaYears.push(yearObj);
    
    this.piaForm.controls['piaArray'].patchValue(this.piaForm.get('piaArray').value.sort((a,b) => {
      return a.Year < b.Year ? -1 : 1
    }))

  }

  removePIAYears() {
    // Weird behavior - running this loop twice removes years outside of our validation
    // Running this loop once for some reason has gaps and adds years that it shouldn't
    // This works for now but is questionable
    let idx = 0;
    while (idx < this.piaYears.value.length) {
      let year = (<FormArray>(<FormArray>this.piaForm.controls['piaArray']).controls[idx]).controls['Year'].value
      if (year < Number(this.piaForm.get('startYear').value) || year > Number(this.piaForm.get('endYear').value)) {
        const control = <FormArray>(this.piaForm.controls['piaArray'])
        control.removeAt(idx)
      }
      idx++;
    }

    idx = 0;
    while (idx < this.piaYears.value.length) {
      let year = (<FormArray>(<FormArray>this.piaForm.controls['piaArray']).controls[idx]).controls['Year'].value
      if (year < Number(this.piaForm.get('startYear').value) || year > Number(this.piaForm.get('endYear').value)) {
        const control = <FormArray>(this.piaForm.controls['piaArray'])
        control.removeAt(idx)
      }
      idx++;
    }

    if (this.piaForm.value.startYear == this.piaForm.value.endYear) {
      idx = 0;
      while (this.piaYears.value.length > 0) {
        const control = <FormArray>(this.piaForm.controls['piaArray'])
        control.removeAt(this.piaYears.value.length - idx)
        idx++;
      }
      this.piaForm.controls['piaArray'].patchValue([this.piaForm.get('piaArray').value[0]])
    }
  }
}